import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'


const LangSelectInner = styled(Select<string>)(({ theme }) => ({
	fontWeight: 'bold !important',
	'& .MuiSelect-select': {
		color: 'primary.main',
	},
	'& .MuiSvgIcon-root': {
		color: 'primary.main',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: 'primary.main !important',
		borderWidth: '2px',
	},
	'&:hover': {
		'& .MuiOutlinedInput-notchedOutline': {
			borderWidth: '3px',
			top: '-4px',
		},
	},
}))

const LangSelect = () => {
	const { t, i18n } = useTranslation()
	const [lang, setLang] = useState(i18n.language)
	const languageSet = (lang: any) => {
		i18n.changeLanguage(lang)
		localStorage.setItem('lang', lang)
		setLang(lang)
	}

	return (
		<FormControl data-cy='lang_select' size='small' sx={{ mt: 0.5 }}>
			<InputLabel sx={{ color: 'primary.main', '&.Mui-focused': { color: 'primary.main' }, fontWeight: 'bold', left: '1px' }} id='lang_select_label'>
				{t('langSelect')}
			</InputLabel>
			<Box sx={{ width: (theme) => theme.spacing(10.5) }}>
				<LangSelectInner
					sx={{ height: (theme) => theme.spacing(4.5) }}
					fullWidth
					margin='dense'
					labelId='lang_select_label'
					label={t('langSelect')}
					name='lang_select'
					value={lang}
					defaultValue={i18n.language}
					onChange={(e: SelectChangeEvent<string>) => {
						languageSet(e.target.value)
					}}
				>
					<MenuItem value='en'>{'EN'}</MenuItem>
					<MenuItem value='ru'>{'RU'}</MenuItem>
					<MenuItem value='am'>{'AM'}</MenuItem>
				</LangSelectInner>
			</Box>
		</FormControl>
	)
}

export default LangSelect
